export enum RelevanceKeysEnum {
    SALES_LESS_MILLION = "SALES_LESS_MILLION",
    SALES_BETWEEN_1_AND_5_MILLION = "SALES_BETWEEN_1_AND_5_MILLION",
    SALES_BETWEEN_5_AND_10_MILLION = "SALES_BETWEEN_5_AND_10_MILLION",
    SALES_OVER_10_MILLION = "SALES_OVER_10_MILLION",

    EMPLOYEES_0_OR_1 = "EMPLOYEES_0_OR_1",
    EMPLOYEES_BETWEEN_2_AND_9 = "EMPLOYEES_BETWEEN_2_AND_9",
    EMPLOYEES_BETWEEN_10_AND_19 = "EMPLOYEES_BETWEEN_10_AND_19",
    EMPLOYEES_OVER_20 = "EMPLOYEES_OVER_20",

    CAPITAL_LESS_MILLION = "CAPITAL_LESS_MILLION",
    CAPITAL_BETWEEN_1_AND_5_MILLION = "CAPITAL_BETWEEN_1_AND_5_MILLION",
    CAPITAL_BETWEEN_5_AND_10_MILLION = "CAPITAL_BETWEEN_5_AND_10_MILLION",
    CAPITAL_OVER_10_MILLION = "CAPITAL_OVER_10_MILLION",
}
